module.exports = __webpack_public_path__ + "img/tampinhas.9b15d860.jpg";